// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__cZKQB","opacity":"Navigation_opacity__ZoZrE"};